import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categorySelect", "roleSelect", "categoryHint"]
  static values = {
    departments: { type: Array, default: [] }
  }

  connect() {
    this.filterCategories()
  }

  toggleOrgField(event) {
    const orgField = document.getElementById("organization-field")
    if (!orgField) return

    if (event.target.value === "org_admin") {
      orgField.classList.remove("hidden")
    } else {
      orgField.classList.add("hidden")
    }
  }

  filterCategories() {
    if (!this.hasCategorySelectTarget || !this.departmentsValue.length) return

    // Selected org IDs from membership selects
    const orgSelects = this.element.querySelectorAll("select[name*='[organization_id]']")
    const selectedOrgIds = new Set()
    orgSelects.forEach(select => {
      if (select.value) selectedOrgIds.add(parseInt(select.value))
    })

    // User-level role drives department type filtering
    const role = this.hasRoleSelectTarget ? this.roleSelectTarget.value : null
    const wantedType = this._deptTypeForRole(role)

    const currentValue = this.categorySelectTarget.value
    const select = this.categorySelectTarget

    while (select.options.length > 1) {
      select.remove(1)
    }

    let filtered = this.departmentsValue
    if (selectedOrgIds.size > 0) {
      filtered = filtered.filter(d => selectedOrgIds.has(d.org_id))
    }
    if (wantedType) {
      filtered = filtered.filter(d => (d.dept_type || 'member') === wantedType)
    }

    filtered.forEach(d => {
      const option = document.createElement("option")
      option.value = d.name
      option.textContent = `${d.name} — ${d.org_name}`
      if (d.name === currentValue) option.selected = true
      select.appendChild(option)
    })

    this._updateHint(role)
  }

  orgChanged() {
    this.filterCategories()
  }

  roleChanged() {
    this.filterCategories()
  }

  _deptTypeForRole(role) {
    if (role === 'employee') return 'employee'
    if (role === 'member') return 'member'
    return null // admin or unset → show all
  }

  _updateHint(role) {
    if (!this.hasCategoryHintTarget) return
    if (role === 'employee') {
      this.categoryHintTarget.textContent = 'Select a department (e.g. Bartender, Valet).'
    } else if (role === 'member') {
      this.categoryHintTarget.textContent = 'Select a member category.'
    } else {
      this.categoryHintTarget.textContent = 'For Members, choose a category. For Employees, choose a department.'
    }
  }
}
